import { render, staticRenderFns } from "./help-icon.vue?vue&type=template&id=09f3116c&"
import script from "./help-icon.vue?vue&type=script&lang=js&"
export * from "./help-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports